//* Import React from library
import React from "react";

//* Import Components from Bootstrap
import { Form, FormControl as Input, InputGroup } from "react-bootstrap";

//* Import components
import { Attention } from "../../../component/base/Attention";

//? Define the props interface
type DescriptionFieldProps ={
  description: string;
  setDescription: React.Dispatch<React.SetStateAction<string>>;
}

/**
 * `DescriptionField` is a memoized functional component that renders an input field for a description.
 * It uses `InputGroup` and `Form.Label` from a UI library to structure the input field.
 * 
 * @param {DescriptionFieldProps} props - The props for the component.
 * @param {string} props.description - The current value of the description.
 * @param {function} props.setDescription - The function to update the description value.
 * 
 * @returns {JSX.Element} The rendered input field component.
 */
export const DescriptionField = React.memo(
  ({ description, setDescription }: DescriptionFieldProps) => (
    <InputGroup className="mb-3">
      <div className="flex fdcolumn flex1">
        <Form.Label>
          Descrição <Attention />
        </Form.Label>
        <Input
          placeholder="Descrição da atribuição"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          as="textarea"
          required
        />
      </div>
    </InputGroup>
  )
);
